import { HttpAuth } from '../../config/Http'
import { changeLoading } from './loading.action';
import { changeNotify } from './notify.action';
import { change as changeVerifySms } from './sms.action'

export const actionTypes = {
    INDEX: 'USUARIOS_INDEX',
    RIFAS: 'USUARIOS_RIFAS',
    BILHETES: 'USUARIOS_BILHETES',
    UPDATE: 'BILHETES_UPDATE'
};

export const indexResponse = (payload, isLoadMore) => ({
    type: actionTypes.INDEX,
    payload,
    isLoadMore
})

export const index = (query, isLoadMore = null) => dispatch => {
    return HttpAuth.get('/usuarios?'+ new URLSearchParams(query))
        .then(res => res && dispatch(indexResponse(res.data, isLoadMore)))
        .catch(error => {
            dispatch( changeLoading({ open: false }) );
    
            if(typeof error.response !== 'undefined') {
                if(error.response.status === 400) {
                    if(typeof error.response.data === 'object'){
                        if(typeof error.response.data.error_code !== undefined) {
                            dispatch(changeVerifySms({
                                open: true,
                                screen_id: 'users.index'
                            }))
                            
                            return false
                        }
                        
                        if(typeof error.response.data.error !== undefined) {
                            if(typeof error.response.data.error === 'string'){
                                dispatch( changeNotify({
                                    open: true,
                                    class: 'error',
                                    msg: error.response.data.error
                                }))
                            }
                        }
                    }
                }
            }
        })
}

// REPORTS

export const reports = (filter) => dispatch => {
    dispatch(changeLoading({ 
        open: true,
        msg: 'Gerando relatório...'
    }))
    return HttpAuth.post('/usuarios/reports', filter)
        .then((res) => {
            if (res.status != 200) throw new Error('Erro na resposta');

            dispatch(changeLoading({ 
                open: false,
                msg: 'Carregando...'
            }))

            if(res.status === 200) {
                const form = document.createElement('form');
                const secureUrl = res.data.url.replace('http:', 'https:');
                const urlObj = new URL(secureUrl)
                form.action = urlObj.origin + urlObj.pathname;
                form.method = 'GET';

                form.style.display = 'none';

                urlObj.searchParams.forEach((value, key) => {
                    const input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = key;
                    input.value = value;
                    form.appendChild(input);
                });
                
                document.body.appendChild(form);
                form.submit();
            }
        })
        .catch((error) => {
            dispatch(changeLoading({ 
                open: false,
                msg: 'Carregando...'
            }))
            
            dispatch(changeNotify({
                open: true,
                msg: 'Erro ao baixar o relatório.',
                class: 'error'
            }))
        });
}